module.exports = __webpack_public_path__ + "img/nlic_thumbnail.f20546ce.jpg";